import LazyLoad from "react-lazyload";

import dynamic from "next/dynamic";

import Img from "components/atoms/Img";
import Title from "components/atoms/Title";
import FormCountries from "components/molecules/FormCountries";
import RefundGuarantee from "components/molecules/RefundGuarantee";
import Banner from "components/organisms/Banner";
import Faqs from "components/organisms/Faqs";
import HowItWorks from "components/organisms/HowItWorks";
import OffshoreCompanyRegistration from "components/organisms/OffshoreCompanyRegistration";
import RequiredDocument from "components/organisms/RequiredDocument";
import StepSlider from "components/organisms/StepSlider";
import WhatMakeUsDifferent from "components/organisms/WhatMakeUsDifferent";

import BankingPackages from "./BankingPackages";
import Packages from "./Packages";
const NewsSlider = dynamic(() => import("components/organisms/NewsSlider"), {
  ssr: false,
});

const Component = ({ data, dataJson }) => {
  const { country } = dataJson;

  return (
    <>
      <section>
        <Banner
          minHeightBanner="banner-min-h-635"
          breadcrumbs={dataJson.breadcrumbs}
          title="Vietnam Company<br/>Registration"
          titleProps={{
            className: "banner-default-title mb-6 lg:mb-10",
            textColor: "banner-title-default-color",
          }}
          leftClassName="col-12 lg:col-7"
          rightClassName="col-12 lg:col-5"
          rightContent={
            <Img
              src={`/assets/images/offshore/country/${dataJson.banner_image}`}
              wrapper={{
                className: "bbc-banner-image-country pb-10 lg:pb-0",
              }}
              className="w-full "
              width={560}
              height={456}
              priority={true}
              alt="register a company in Vietnam"
            />
          }
          bgColor={"bg-bbc-country"}
          dataTrustpilot={{
            dataStatic: dataJson.dataTrustpilot,
            dataDefault: data.dataTrustpilot,
          }}
        ></Banner>
      </section>
      <section>
        <OffshoreCompanyRegistration data={dataJson.dataRegistration} />
      </section>
      <section>
        {dataJson.dataOpenBankAccount &&
          typeof dataJson.dataOpenBankAccount === "object" &&
          Object.keys(dataJson.dataOpenBankAccount).length > 0 && (
            <StepSlider
              description="Foreign investors who want to set up a company in Vietnam will have to acquire two license types, namely the investment license and the enterprise license. Note that the licensing requirements can change depending on factors such as company ownership."
              data={dataJson.dataOpenBankAccount}
              className="pt-0 lg:pt-0"
              title={dataJson.dataOpenBankAccount.title}
              imgAlt={dataJson.dataOpenBankAccount.alt}
            />
          )}
      </section>

      <Img
        src="/assets/images/wave/opposition-wave.png"
        width={1920}
        height={86}
        className="w-full"
        wrapper={{ className: "w-full" }}
        alt="Wave top"
      />
      <div className="bg-bbc-brand-100">
        <div className="container">
          <Packages
            data={data?.dataPackage || []}
            dataStatic={dataJson.dataPackage}
            title={"Vietnam Company Formation Packages"}
          />
          <BankingPackages
            data={dataJson.dataBankingPackage}
            title={"Banking support package for Vietnam companies"}
          />
          <RefundGuarantee className="mb-10 lg:mb-20" />
          <div className="row items-center pb-10 lg:pb-20">
            <div className="justify-self-start lg:col-6">
              <div className="h-full">
                <Title
                  text="Bring your next business venture online"
                  className="bbc-title text-bbc-40px text-bbc-brand-800"
                />
              </div>
            </div>
            <div className="lg:col-6">
              <div className="h-full">
                <LazyLoad>
                  <iframe
                    src="https://www.youtube.com/embed/8RkJwKEXKPU?start=2"
                    width="540"
                    height="303"
                    frameBorder="0"
                    title="Bring your next business venture online"
                    allow="accelerometer; autoplay;encrypted-media; gyroscope;picture-in-picture"
                    allowFullScreen
                    className=" w-full"
                  ></iframe>
                </LazyLoad>
              </div>
            </div>
          </div>
        </div>
        <section>
          <WhatMakeUsDifferent
            data={dataJson.dataWhatMakeUsDifferent}
            className="bg-wmud py-[60px]"
          />
        </section>
        <HowItWorks
          title={`${country} Company Incorporation Process`}
          // SubTitle="Company Incorporation Process"
          data={dataJson.dataHowItWorks}
          className="py-10 lg:py-20"
        />
        <RequiredDocument
          title="Required Documents"
          data={dataJson.dataRequiredDocument}
          sectionClassName="py-10 lg:py-20"
          backgroundImage="/assets/images/common/required-documents.png"
        />
      </div>

      <section className="relative">
        <div className=" absolute hidden h-1/2 w-full bg-bbc-brand-100 md:block"></div>
        <div className="container relative z-10 pt-10 lg:pt-20">
          <div className="m-auto lg:col-10">
            <FormCountries
              title={dataJson.dataFormContact.title}
              description={dataJson.dataFormContact.description}
              country_id={244}
            />
          </div>
        </div>
        <Img
          src="/assets/images/wave/curve_bot-wave.svg"
          width={1920}
          height={86}
          className="w-full"
          wrapper={{ className: "absolute w-full top-1/2 hidden md:block" }}
          alt="Wave bottom"
        />
      </section>
      <section>
        <div className="container">
          <div className="m-auto lg:col-10">
            <Faqs
              data={dataJson.dataFaqs}
              title={dataJson.dataFaqs.title}
              description={dataJson.dataFaqs.description}
              defaultActiveKey={dataJson.dataFaqs.defaultActiveKey}
              multipleOpen={dataJson.dataFaqs.multipleOpen}
            />
          </div>
        </div>
      </section>
      <section className="mb-0">
        <div className="container">
          <Title className="title-h2 m-auto mb-10 w-2/3 pb-0 text-center text-bbc-brand-800">
            Industry News & Insights
          </Title>
          <LazyLoad>
            <NewsSlider data={data} />
          </LazyLoad>
        </div>
      </section>
    </>
  );
};

export default Component;
